/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/packs and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

import Rails from "@rails/ujs"
import 'core-js/stable'
import 'regenerator-runtime/runtime'

import 'simplebar'
import 'simplebar/dist/simplebar.css'
import '../controllers'

// Функция для проверки, включена ли Яндекс.Метрика для текущего домена
function isYandexMetrikaEnabled() {
  const settings = window.YANDEX_METRIKA_SETTINGS || {};
  const currentDomain = window.location.hostname;
  const targetMetrikaId = settings.id || '21334294';
  
  console.log('Текущие настройки:', settings);
  
  // Проверяем, есть ли ID метрики
  if (!settings.id) {
    console.log('ID Яндекс.Метрики не найден в настройках');
    return false;
  }
  
  // Проверяем, не отключена ли метрика для текущего домена
  if (settings.disabled_domains && settings.disabled_domains.includes(currentDomain)) {
    console.log(`Яндекс.Метрика (ID: ${targetMetrikaId}) отключена для домена ${currentDomain}`);
    return false;
  }
  
  // Проверяем наличие объекта ym
  if (typeof window.ym === 'undefined') {
    console.log('Объект ym не найден, возможно скрипт Яндекс.Метрики не загружен');
    return false;
  }
  
  console.log(`Яндекс.Метрика (ID: ${targetMetrikaId}) подключена для домена ${currentDomain}`);
  return true;
}

// Проверяем статус Яндекс.Метрики при загрузке страницы
document.addEventListener('DOMContentLoaded', () => {
  console.log('Проверка статуса Яндекс.Метрики...');
  isYandexMetrikaEnabled();
});

Rails.start()
Rails.href = (element) => element.dataset.href || element.href;

window.yaInit = function (...args) {
  const event = document.createEvent('Events')
  event.initEvent('yandex-map-callback', true, true)
  event.args = args
  window.dispatchEvent(event)
}

window.recaptchaInit = function() {
  const event = document.createEvent('Events')
  event.initEvent('recaptcha-callback', true, true)
  window.dispatchEvent(event)
}

window.calltouchEvent = function(events) {
  console.log(events);
  if (events[0].action == 'create' && events[0].data.widgetType == 'promotion') {
    ym(21334294,'reachGoal','Calltouch Widget')
  }
}

window.recaptchaSuccess = function() {
  window.dispatchEvent(new CustomEvent('recaptcha-success'))
}

window.recaptchaError = function() {
  window.dispatchEvent(new CustomEvent('recaptcha-error'))
}

window.recaptchaExpired = function() {
  window.dispatchEvent(new CustomEvent('recaptcha-expired'))
}

window.sendCalltouchForm = function(calltouchKey, obj) {
  if (!calltouchKey) { return; }

  new Promise(function(resolve, reject) {
    try {
      window.ctw.getRouteKeyData(calltouchKey, function(success, data) {
        console.log(success, data);
        if (success) {
          if (data.widgetFound) {
            resolve('виджет найден');
          } else {
            reject('не найден включенный виджет по routeKey, либо услуга обратного звонка не активна');
          }
        } else {
          reject('во время обработки прозошла ошибка');
        }
      })
    } catch (e) {
      reject('calltouch не работает');
    }
  }).then(function(message) {
    console.log(message);

    return new Promise(function(resolve, reject) {
      if (obj.phone) {
        try {
          window.ctw.createRequest(calltouchKey, obj.phone, obj.info, function(success, data) {
            console.log(success, data);

            if (success) {
              resolve('Создана заявка на колбек, идентификатор: ' + data.callbackRequestId);
            } else {
              reject('Во время выполнения запроса произошла ошибка: ' + data.type);
            }
          })
        } catch (e) {
          reject('calltouch не работает');
        }
      } else {
        reject('Нет номера телефона');
      }
    })
  }).then(function(message) {
    console.log(message);
    ym(21334294,'reachGoal','Calltouch Order Form');
    ym(21334294,'firstPartyParams', {
      'email': obj.email,
      'phone_number': obj.phone,
      'first_name': obj.first_name,
      'last_name': obj.last_name,
      "home_address": {
        "city": obj.city,
        "country": 'россия'
      }
    })
  })
  .catch(function(message) { console.log(message); })
}
